import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vidondgalery',
  templateUrl: './vidondgalery.component.html',
  styleUrls: ['./vidondgalery.component.css']
})
export class VidondgaleryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
